<template>
    <div>
        <div class="map-general">
            <l-map
                    ref="myMap"
                    :zoom="zoom"
                    :center="center"
                    :options="mapOptions"
                    @update:center="centerUpdate"
                    @update:zoom="zoomUpdate"
                    @click="clickMark"
            >
                <l-tile-layer
                        :url="url"
                        :attribution="attribution"
                />
                <l-marker :draggable="true" :lat-lng.sync="item.position"
                          :icon="myIcon" v-for="item in marks" :key="item.position.lng"
                />
            </l-map>
        </div>
        <dialog-loading :dialog="routeLoadingDialog" title="Buscando la ruta"></dialog-loading>
    </div>
</template>

<script>
  import {LMap, LMarker, LPopup, LTileLayer, LTooltip} from 'vue2-leaflet'
  import {OpenStreetMapProvider} from 'leaflet-geosearch'
  import LGeosearch from 'vue2-leaflet-geosearch'
  import LGeocoder from 'leaflet-control-geocoder'
  import Routing from 'leaflet-routing-machine'
  import 'leaflet-routing-machine/dist/leaflet-routing-machine.css'
  import DialogLoading from '@/components/widgets/loading/DialogLoading'
  export default {
    name: 'GeoMap',
    components: {
      LMap,
      LTileLayer,
      LMarker,
      LPopup,
      LTooltip,
      LGeosearch,
      DialogLoading
    },
    props: {
      latlng: {
        type: Object,
        required: false,
        default: () => {
          return {latlng: {lat: 41.390205, lng: 2.154007}}
        },
        validator: function (value) {
          return Object.keys(value).length > 0
        }
      }
    },
    data() {
      return {
        geosearchOptions: {
          provider: new OpenStreetMapProvider(),
        },
        addRoute: false,
        lastControl: null,
        routeLoading: false,
        routeLoadingDialog: false,
        zoom: 1,
        center: L.latLng(41.390205, 2.154007),
        url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        currentZoom: 1,
        currentCenter: L.latLng(0, 0),
        showParagraph: false,
        mapOptions: {
          zoomSnap: 0.5
        },
        marks: [],
        searchResult: [],
        myIcon: L.icon({
          iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
          iconSize: [25, 41],
          iconAnchor: [16, 37],
          shadowUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-shadow.png',
          shadowSize: [41, 41],
          shadowAnchor: [16, 37]
        }),
        listLocation: 0,
        geoError: false,
        geoLatLng: null
      }
    },
    watch: {
      geoRoute: function (val) {
        if (this.addRoute && this.lastControl) {
          this.$refs.myMap.mapObject.removeControl(this.lastControl)
          this.addRoute = false
        }
        if (val) {
          this.addRoute = true
          this.lastControl = val
          this.$refs.myMap.mapObject.addControl(val)
        }
      }
    },
    computed: {
      geoRoute() {
        let me = this
        if (this.latlng && this.geoLatLng) {
          if (!me.latlng.latlng.lat || !me.latlng.latlng.lng || !me.geoLatLng.lat || !me.geoLatLng.lng) {
            return null
          }
          return L.Routing.control({
            waypoints: [
              L.latLng(me.latlng.latlng.lat, me.latlng.latlng.lng),
              L.latLng(me.geoLatLng.lat, me.geoLatLng.lng)
            ],
            language: me.$i18n.locale,
            geocoder: L.Control.Geocoder.google('AIzaSyAtP51Sa1yUYoV2V8pML6iZo25qd7_tuAI'),
            showAlternatives: true,
            altLineOptions: {
              styles: [{
                color: 'black', opacity: 0.15, weight: 9
              }, {
                color: 'white',
                opacity: 0.8,
                weight: 6
              }, {
                color: 'blue', opacity: 1, weight: 2
              }],
              addWaypoints: true,
              missingRouteStyles: [
                {
                  color: 'black', opacity: 0.15, weight: 7
                }, {
                  color: 'white',
                  opacity: 0.6,
                  weight: 4
                }, {color: 'gray', opacity: 0.8, weight: 2, dashArray: '7,12'}]
            }
          })
            .addEventListener('routingerror', me.errorRoute)
            .addEventListener('routingstart', me.searchRoute)
            .addEventListener('routesfound', me.foundRoute)
        }
        return null
      }
    },
    mounted() {
      this.center = L.latLng(this.latlng.latlng.lat, this.latlng.latlng.lng)
      navigator.geolocation.getCurrentPosition(this.success, this.error)
      this.$nextTick(() => {
        this.$refs.myMap.mapObject.invalidateSize()
      })
      let me = this
      setTimeout(function () {
        me.$refs.myMap.mapObject.invalidateSize()
      }, 1000)
      //this.clickMark(this.latlng)
    },
    methods: {
      zoomUpdate(zoom) {
        this.currentZoom = zoom
      },
      centerUpdate(center) {
        this.currentCenter = center
      },
      showLongText() {
        this.showParagraph = !this.showParagraph
      },
      innerClick() {
        // alert('Click!')
      },
      clickMark(item) {
        console.log(this.$refs.myMap.mapObject)
        /* this.marks = []
        this.marks.push({
          position: item.latlng
          }
        )
        this.center = L.latLng(this.marks[0].position.lat, this.marks[0].position.lng) */
      },
      autoCenter() {
        // this.center = L.latlng(41.390205, 2.154007)
        // this.zoom = 7
      },
      routing() {
        Routing()
        LGeocoder()// Evita que el optimizador de codigo elimine el import de Routing
      },
      success(position) {
        this.geoLatLng = {lat: position.coords.latitude, lng: position.coords.longitude}
      },
      error() {
        this.geoLatLng = null
        console.log('Error en la geolocalizacion')
      },
      errorRoute() {
        this.geoLatLng.lat += 0.0000001
      },
      searchRoute() {
        this.routeLoadingDialog = true
      },
      foundRoute() {
        this.routeLoadingDialog = false
      }
    }
  }
</script>
<style lang="scss">
    .map-general {
        height: 100%;
        max-height: 600px;
        min-height: 600px;
        max-width: 100%;
        margin: 0;
    }

    .success--text {
        color: green;
    }

    .error--text {
        color: red;
    }
</style>